var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.3 8.45a1.35 1.35 0 0 1 2.7 0v5.4a1.35 1.35 0 1 1-2.7 0zM3.9 8.3v4.887a1.8 1.8 0 0 0 .995 1.61l.045.023a3.6 3.6 0 0 0 1.61.38h4.874a1.8 1.8 0 0 0 1.765-1.447l1.08-5.4A1.8 1.8 0 0 0 12.504 6.2H9.3V2.6A1.8 1.8 0 0 0 7.5.8a.9.9 0 0 0-.9.9v.6a3.6 3.6 0 0 1-.72 2.16L4.62 6.14A3.6 3.6 0 0 0 3.9 8.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.92ea2246c7b8796352b1b82cb4aa47c2.svg";
export { ForwardRef as ReactComponent };